// @flow

import styled from 'styled-components'

export const Card = styled.div`
	box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
	background-color: white;
	border-radius: var(--base-border-radius);
`
